<template>
  <div :class="{contentWrap:true,noNav:$store.state.isWx}">
    <div class="container">
      <van-nav-bar
        :title="title"
        fixed
        v-if="!$store.state.isWx"
        @click-left="$router.go(-1)"
        left-arrow/>
      <scroll ref="scroll">

        <div>
          <div class="title">发票规则说明</div>
          <div class="group">
            <h2 class="item">旅游、娱乐消费项目</h2>
            <p>您好，为了给您提供方便，我公司可以为您开具正规的旅游发票：</p>
            <ul>
              <li>(1)发票内容：文化服务；</li>
              <li>(2)如何确定内容和抬头：需要开发票的游客可与您的客服联系，确定开发票内容与抬头，最好以短信形式发送告知，以避免同音等原因开错而不能报销的问题；</li>
              <li>(3)如何取得：在您游玩结束送团时交给您。如因各种原因未能及时交给您，请您告知邮寄地址，我们会邮寄给您！</li>
            </ul>
          </div>
          <div class="title">电子发票常见问答</div>
          <div class="group">
            <div class="item">
              <h2>什么是电子发票</h2>
              <p>电子发票就是电子形式的发票，其发票代码、开票机构、金额等信息以及打印后版式均与纸质发票相同。电子发票在保管、查询、调阅时更加便捷。</p>
            </div>

            <div class="item">
              <h2>如何验证电子发票的真伪？</h2>
              <p>电子发票下载成功后，您可通过当地国税局提供的电子发票查询平台，输入电子发票信息进行验证。</p>
            </div>

            <div class="item">
              <h2>我的发票抬头写错了，需要重开发票怎么办？</h2>
              <p>您可以拨打电子发票服务热线，提供已开具的电子发票信息以及正确的开票信息（发票抬头，电子邮箱）。之后xxxxxx公司会取消原错误发票后重新开票，将正确的电子发票发送至您预留的电子邮箱。</p>
            </div>

            <div class="item">
              <h2>我可否定义电子发票的开票内容，如购买门票选择办公用品？</h2>
              <p>很抱歉，根据法规要求，开票内容与您购买的产品或服务自动匹配，不允许修改。</p>
            </div>

            <div class="item">
              <h2>已正确填写电子邮箱，多久能获取电子发票？</h2>
              <p>游客填写完开票信息并提交开票，正常5分钟内就可以收到发票信息（需要必填项，手机号码或邮箱选项其一）</p>
            </div>

            <div class="item">
              <h2>收到的发票为何无法在税务局查到？</h2>
              <p>查验电子发票真伪需要开票后24小时后到国税官网查询 https://inv-veri.chinatax.gov.cn/</p>
            </div>

          </div>

          <div class="copyright">
            <p>Copyright(C) 2004－2020 ectrip.com All Rights Reserved.</p>
            <p>景区服务热线：0514-87357803</p>
          </div>

        </div>

      </scroll>
    </div>

  </div>
</template>

<script>
export default {
  name: 'InvoiceHelp',
  mounted () {
    this.$nextTick(() => {
      this.$refs.scroll.scroll.refresh()
    })
  },
  data () {
    return {
      title: this.$route.meta.title
    }
  }
}
</script>

<style scoped lang="stylus">
.container
  font-size: .2rem
  font-family: '微软雅黑';
  background-color: #f2f2f2
.title
  font-size: .28rem
  font-weight: 600
  padding .21rem .33rem
  line-height: .5rem

.group
  padding:0 .32rem .7rem
  background-color: #fff
  h2
    font-size: .22rem
    font-weight: 700;
    line-height:.4rem;
  p
    line-height:.4rem;
    text-indent:2em
  li
    text-indent 2em
    line-height:.35rem
    padding:.1rem 0
.item
  padding-top:.3rem
  p
    line-height: .35rem
    text-indent:2em
.copyright
    margin-top: .3rem
    padding-top: .1rem
    border-top: .02rem solid #D7D7D7
    font-size: .2rem
    color: #9CA5A9
    text-align: center
    line-height: .45rem
</style>



// WEBPACK FOOTER //
// src/page/InvoiceHelp.vue